module.exports = __webpack_public_path__ + "img/pfp.34c55824.png";